<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <div class="f-bd f14 text-nowrap">{{$t('op_date')}}{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5" v-if="mod_cat == 'M1'">
                    <el-input size="small" v-model="search.org_code" :placeholder="$t('code_cname')">
                        <span slot="prepend">{{$t('org')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.content">
                        <span slot="prepend">{{$t('content')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.add_user">
                        <span slot="prepend">{{$t('op_user')}}{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.add_ip">
                        <span slot="prepend">IP{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" style="width: 100%" height="100%">
                    <el-table-column fixed prop="add_time" :label="listHeader.add_time" width="150px"></el-table-column>
                    <el-table-column prop="add_user_cname" :label="listHeader.add_user_cname" width="100px"></el-table-column>
                    <el-table-column prop="add_ip" :label="listHeader.add_ip" width="120px"></el-table-column>
                    <el-table-column prop="org_cname" :label="listHeader.org_cname" min-width="150px"></el-table-column>
                    <el-table-column prop="role_cname" :label="listHeader.role_cname" width="150px"></el-table-column>
                    <el-table-column prop="content" :label="listHeader.content" min-width="250px"></el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
    </div>
</template>

<script>
    import myPager from '../../components/myPager'
    import myNodata from '../../components/myNodata'
    import myDropdown from '../../components/myDropdown'
    import myDatePicker from '../../components/myDatePicker'
    export default {
        name:"system-ops",
        components:{
            myPager,
            myNodata,
            myDropdown,
            myDatePicker
        },
        data:function(){
            const listHeader = {
                add_time: this.$t('op_date'),
                org_cname: this.$t('org_cname'),
                role_cname: this.$t('use_role_cname'),
                content: this.$t('content'),
                add_user_cname: this.$t('op_user'),
                add_ip: 'IP',
            };
            return{
                mod_cat:this.$base.getModCat(),
                search:{
                    search_url: "system/ops-list",
                    datearea_id:1,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    org_code: '',
                    content: '',
                    add_user: '',
                    add_ip: '',
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.list();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/ops.vue